import { cn } from '@/lib/utils';


export const navRow = (active: boolean) =>
  cn(
    'h-auto w-full gap-3 rounded-lg px-2 py-2 text-[14.5px] transition',
    active
      ? '!bg-card font-semibold !text-text-strongest shadow-[0_1px_2px_rgba(16,24,40,0.06),0_0_0_1px_rgba(16,24,40,0.04)]'
      : 'font-medium text-text-default hover:!bg-card/60 hover:!text-text-strongest',
  );

export const navToggle = (active: boolean) =>
  cn(
    'flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition hover:bg-card',
    active ? 'text-text-strongest' : 'text-text-subtle hover:text-text-strongest',
  );

export const navSubRow = (active: boolean) =>
  cn(
    'h-auto w-full gap-2.5 rounded-md py-2 pl-[21px] pr-2 text-left text-[13.5px] font-medium transition',
    active
      ? '!bg-transparent !text-text-strongest'
      : 'text-text-muted hover:!bg-transparent hover:!text-text-strongest',
  );

export const navSubDot = (active: boolean) =>
  cn('-mr-1 h-1.5 w-1.5 shrink-0 rounded-full', active ? 'bg-brand' : 'bg-transparent');

export const navRailRow = (active: boolean) =>
  cn(
    'mx-auto flex h-11 w-11 items-center justify-center rounded-lg transition',
    active
      ? '!bg-brand !text-white shadow-[0_2px_6px_rgba(14,182,79,0.30)]'
      : 'text-text-muted hover:!bg-brand-subtle hover:!text-text-strongest',
  );

export const navIcon = (active: boolean, onBrandFill = false) =>
  cn(
    'h-5 w-5 shrink-0 bg-current transition-colors',
    onBrandFill && active
      ? 'text-white'
      : active
        ? 'text-text-strongest'
        : 'text-text-muted',
  );
